import * as React from 'react';
import { useState } from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { withRouter } from 'src/node_modules/kts-platform-frame/routes';
import { Input, Icon, Button, Tooltip } from 'antd';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import MyIcon from 'src/display/components/Icon';
import UIHead from './UI.Head';
import AppSdk from 'kts-platform-frame/appSdk';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    updateVisible: (visible: boolean)=>void;
}

class MyState {

    /** 搜索文本 */
    search: string;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class extends UIBasic<IProps, ModulesState> {

    state = new MyState();

    private searchRef:Input;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        ModulesAction.updateAppList();
        ModulesAction.queryCatory();
        // this.searchRef.input.focus();
        AppSdk.instance.onEvent('myAppChangeEvent', ModulesAction.updateAppList);
    }

    render() {
        // 封装分组数据
        let groupArr = [];
        let groupArrObj = [];
        this.modulesState.myAppList.map((value, index) => {
            // 没有分类设置为其他分类
            if(!value['appCategoryName']) {
                value['appCategoryName'] = '其他';
            }
            // 最开始如果没有存在的数据依次增加一遍，且添加到分组里面
            if(groupArr.indexOf(value['appCategoryName']) === -1) {
                groupArr.push(value['appCategoryName']);
                groupArrObj.push({
                    categoryName: value['appCategoryName'],
                    categoryValue: [value],
                });
            }else{
                // 循环去重数据，判断相等则添加到对应的分组里面
                groupArr.map((tar,idx) => {
                    if(tar === value['appCategoryName']){
                        groupArrObj[idx].categoryValue.push(value);
                    }
                });
            }
        });
        return (
            <div className={css.appBox}>
                <div className={css.searchContainer}>
                    <UIHead />
                    {/* <Input
                        ref={e => { this.searchRef = e; }}
                        size="large"
                        value={this.state.search}
                        onChange={e => { this.setState({ search: e.target.value }); }}
                        className={css.search}
                        prefix={<a><Icon type="search" /></a>}
                        placeholder="搜索…"
                    /> */}
                </div>
                <div className={css.buttList} >
                    {/* <div className={css.tipsBtn}><span className={css.tipsIcon} ><MyIcon src={require('./Icon/tips.svg')}/></span>点击图钉可添加应用到左侧快捷菜单</div> */}
                    <div style={{marginRight: '0', marginLeft: 'auto'}}>
                        <Button onClick={this.onClickPenHandler} type="primary" className={css.primary} style={{marginRight: '20px'}}>我的应用</Button>
                        <Button onClick={this.onClickStoreHandler} type="primary" className={css.primary} >应用商店</Button>
                    </div>
                </div>
                <hr className={css.hr} />
                <div className={css.appCategoryWrap}>
                    {
                        this.modulesState.myAppList.map((item, idx) => {
                            return <div 
                                key={item.categoryName} 
                                style={{ display: (this.state.search&&item.appInstanceList&&item.appInstanceList.every(tar=>{
                                    return tar.appName.indexOf(this.state.search) < 0;
                                })) ? 'none' : 'block' }}
                            >
                                <p className={css.appCategoryName}>{item.categoryName}</p>
                                <ul className={css.appList} >
                                    {
                                        item.appInstanceList&&item.appInstanceList.map((value, index) => {
                                            const search = this.state.search;
                                            let isOk = true;
                                            if (search && value.appName.indexOf(search) < 0) {
                                                isOk = false;
                                            }
                                            return <li key={index} style={{ display: isOk ? 'block' : 'none' }} >
                                                <div className={css.appItem} onClick={()=>this.onClickAppItemHandler(value)} >
                                                    <div className={css.appItemTitle}>
                                                        <AppImg src={mediaUrl() + value.appIcon} />
                                                        {
                                                            value.appName.length < 8 ? <span className="text-overflow" >{value.appName}</span> :
                                                            <Tooltip title={value.appName} ><span className="text-overflow" >{value.appName.slice(0,7)+'...'}</span></Tooltip>
                                                        }
                                                        
                                                    </div>
                                                    <div className={css.appItemIcon} onClick={(e)=>this.handleUsedIcon(e,value)}>
                                                        {
                                                            value.isPopular === 1 ? <Tooltip title={'取消常用'} key="cancel"><div><MyIcon src={require('./Icon/solidDot.svg')}/></div></Tooltip>:
                                                            <Tooltip title={'添加常用'} key="add"><div className={css.nullDot}><MyIcon src={require('./Icon/nullDot.svg')}/></div></Tooltip>
                                                        }
                                                    </div>
                                                </div>
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>;
                        })
                    }
                </div>
            </div>
        );
    }

    // 常用图标点击事件
    private handleUsedIcon = (e,value) => {
        ModulesAction.quickSetUsed(value);
        e.stopPropagation();
        e.preventDefault();
    }
    /** 点击了 app */
    private onClickAppItemHandler = (value) => {
        this.props.updateVisible(false);
        this.props.history.push(`/workbench/m/${value.appKey}`);
    }

    /** 点击了 应用商店 */
    private onClickStoreHandler = () => {
        this.props.updateVisible(false);
        this.props.history.push('/workbench/m/Kingxunlian.AppStore');
    }

    /** 点击了笔 */
    private onClickPenHandler = () => {
        this.props.updateVisible(false);
        this.props.history.push('/workbench/m/Kingxunlian.AppStore/?routing=list%2Fmyapp');
    }
}

/** APP 图标组件 */
function AppImg(props: any) {

    const [url, setUrl] = useState(props.src || require('./Icon/img.default.svg'));

    function onError() {
        setUrl(require('./Icon/img.default.svg'));
    }

    return <img src={url} onError={onError} alt="" />;
}


// WEBPACK FOOTER //
// ./src/display/apps/AppSearch/UI.AppBox/index.tsx